import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import payrateIcon from "../images/payrateIcon.svg";
import { useLocation, Link } from "react-router-dom";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import InvoiceDisplay from "./InvoiceDisplay";
import LoaderForm from "./LoaderForm";
import "../styles/GenerateInvoice.css";
import DefaultEmployeeProfile from "../images/DefaultEmployeeProfile.svg";
import startingDateIcon from "../images/startingDateIcon.svg";
import endingDateIcon from "../images/endingDateIcon.svg";
import additionsIcon from "../images/additionsIcon.svg";
import deductionsIcon from "../images/deductionsIcon.svg";
import hoursWorkedIcon from "../images/hoursWorkedIcon.svg";
import minutesWorkedIcon from "../images/minutesWorkedIcon.svg";
import propertyIcon from "../images/propertyIcon.svg";
import salaryIcon from "../images/salaryIcon.svg";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAuth } from "../auth/auth";
import { PERMISSIONS } from "../utils/rbac";
import { useRoutePermissionGuard } from "../hooks/usePermissionGuard";
import { formatDisplayDate } from "../utils/displayDate";

const apiUrl = process.env.REACT_APP_API_URL;

const parsePeriodFromSearch = (search) => {
  const params = new URLSearchParams(search);
  const startDateParam = params.get("startDate");
  const endDateParam = params.get("endDate");
  const from = startDateParam ? new Date(startDateParam) : null;
  const to = endDateParam ? new Date(endDateParam) : null;
  return {
    from: from && !Number.isNaN(from.getTime()) ? from : null,
    to: to && !Number.isNaN(to.getTime()) ? to : null,
  };
};

const mergePeriodWithQuery = (search, payFromDate, payToDate) => {
  const query = parsePeriodFromSearch(search);
  return {
    payFromDate: query.from ?? payFromDate,
    payToDate: query.to ?? payToDate,
  };
};

const EditInvoice = () => {
  const { allowed: canEditPayslip, PermissionDialog } = useRoutePermissionGuard(
    PERMISSIONS.EDIT,
    "edit payslip",
  );
  const [user, setUser] = useState({});
  const [employees, setEmployees] = useState([]);
  const [rangeIdGet, setRangeId] = useState(0);
  const [invoice, setInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userStateId, setStateUserId] = useState();
  const [userId, setuserId] = useState();
  const [userEmail, setUserEmail] = useState();
  const [choosedRate, setChoosedRate] = useState("");
  const [imageURL, setImageURL] = useState("");
  const [selectOpen, setSelectOpen] = useState(false);
  const [invoiceId, setInvoiceId] = useState(
    () => new URLSearchParams(window.location.search).get("id"),
  );
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const startDatePickerRef = useRef(null);
  const endDatePickerRef = useRef(null);
  const [formDataList, setFormDataList] = useState([]);
  const [additionsType, setAdditionsType] = useState("");
  const [deductionsType, setdeductionsType] = useState("");
  const [property, setProperty] = useState("");
  const [btnText, setBtnText] = useState("Update");
  const [propertyList, setPropertyList] = useState([]);
  const [additionsTypeList, setAdditionsTypeList] = useState([]);
  const [deductionssTypeList, setDeductionssTypeList] = useState([]);
  const [editedIndex, setEditedIndex] = useState(null);
  const [userRates, setUserRates] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [isOpenEndDate, setIsOpenEndDate] = useState(false);
  const [bfcacheRestoreKey, setBfcacheRestoreKey] = useState(0);
  useAuth();

  const location = useLocation();

  useEffect(() => {
    const onPageShow = (event) => {
      setMessage(null);
      if (!event.persisted) return;
      window.location.reload();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);
  // useEffect(() => {
  //   if (location.state) {
  //     setInvoiceId(location.state);
  //   }
  // }, [location.state]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    if (id) {
      setInvoiceId(id);
    }
  }, [location.search, location.key]);

  useEffect(() => {
    const fetchInvoiceDetail = async () => {
      try {
        setLoading(true);
        setIsLoading(true);

        const response = await axios.post(`${apiUrl}/getInvoiceDetail`, {
          id: invoiceId,
        });

        const invoiceData = response.data.data;

        setInvoice(invoiceData);

        let formDataListArray = [];
        try {
          const parsed = JSON.parse(invoiceData.formDataList || "[]");
          formDataListArray = Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          formDataListArray = [];
        }
        // Populate the information table with all existing rows
        setFormDataList(formDataListArray);
        if (formDataListArray.length > 0) {
          const formDataList = formDataListArray[0];
          const savedHourlyRate =
            formDataList.hourlyRate !== undefined &&
            formDataList.hourlyRate !== null &&
            formDataList.hourlyRate !== ""
              ? parseFloat(formDataList.hourlyRate)
              : "";

          const today = new Date();
          today.setUTCHours(18, 30, 0, 0);
          const formattedToday = today.toISOString();

          const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
          tomorrow.setUTCHours(18, 30, 0, 0);
          const formattedTomorrow = tomorrow.toISOString();

          const topPayFromDate = invoiceData.payFromDate;
          const topPayToDate = invoiceData.payToDate;
          const defaultFrom = topPayFromDate
            ? new Date(topPayFromDate)
            : formDataList.payFromDate
              ? new Date(formDataList.payFromDate)
              : new Date(formattedToday);
          const defaultTo = topPayToDate
            ? new Date(topPayToDate)
            : formDataList.payToDate
              ? new Date(formDataList.payToDate)
              : new Date(formattedTomorrow);
          const { payFromDate, payToDate } = mergePeriodWithQuery(
            location.search,
            defaultFrom,
            defaultTo,
          );

          const newFormValues = {
            payFromDate,
            payToDate,
            Additions: formDataList.Additions,
            Deductions: formDataList.Deductions,
            paymentType: formDataList.paymentType,
          };

          if (formDataList.paymentType === "salary") {
            newFormValues.salary = formDataList.salary;
          } else {
            newFormValues.hours = formDataList.hours;
            newFormValues.minutes = formDataList.minutes;
            newFormValues.choosedRate = savedHourlyRate;
          }

          formik.setValues(newFormValues);

          if (formDataList.paymentType !== "salary") {
            formik.setFieldValue("hours", formDataList.hours);
            formik.setFieldValue("minutes", formDataList.minutes);
            formik.setFieldValue("choosedRate", savedHourlyRate);
            setChoosedRate(savedHourlyRate);
          } else {
            // If it's a salary type, you can set the salary value
            formik.setFieldValue("salary", formDataList.salary);
          }
          setAdditionsType(formDataList.additionsType);
          setdeductionsType(formDataList.deductionsType);
          setEditedIndex(0);
          setBtnText("Update");
          const rangeFromQuery = new URLSearchParams(location.search).get(
            "rangeId",
          );
          setRangeId(
            rangeFromQuery
              ? Number(rangeFromQuery)
              : response.data.data.range_id,
          );
          setProperty(formDataList.property);
          setStateUserId(response.data.data.userId);
          setUserEmail(response.data.data.email);
        } else {
          const today = new Date();
          today.setUTCHours(18, 30, 0, 0);
          const formattedToday = today.toISOString();

          const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
          tomorrow.setUTCHours(18, 30, 0, 0);
          const formattedTomorrow = tomorrow.toISOString();

          const emptyDefaults = {
            payFromDate: invoiceData.payFromDate
              ? new Date(invoiceData.payFromDate)
              : new Date(formattedToday),
            payToDate: invoiceData.payToDate
              ? new Date(invoiceData.payToDate)
              : new Date(formattedTomorrow),
          };
          const emptyPeriod = mergePeriodWithQuery(
            location.search,
            emptyDefaults.payFromDate,
            emptyDefaults.payToDate,
          );

          const newFormValues = {
            payFromDate: emptyPeriod.payFromDate,
            payToDate: emptyPeriod.payToDate,
            Additions: 0,
            Deductions: 0,
            paymentType: "hourly",
          };

          newFormValues.hours = 0;
          newFormValues.minutes = 0;

          formik.setValues(newFormValues);
          formik.setFieldValue("hours", 0);
          formik.setFieldValue("minutes", 0);

          setAdditionsType("");
          setdeductionsType("");
          const rangeFromQuery = new URLSearchParams(location.search).get(
            "rangeId",
          );
          setRangeId(
            rangeFromQuery
              ? Number(rangeFromQuery)
              : response.data.data.range_id,
          );
          setProperty("");
          setStateUserId(response.data.data.userId);
          setUserEmail(response.data.data.email);
        }
      } catch (error) {
        //console.error("Error fetching invoice detail:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (invoiceId != null) {
      fetchInvoiceDetail();
    }
  }, [invoiceId, location.search, location.key, bfcacheRestoreKey]);

  useEffect(() => {
    if (userStateId) {
      const fetchUserDetails = async () => {
        try {
          const response = await axios.post(`${apiUrl}/getEmployeeDetail`, {
            id: userStateId,
          });
          setUser(response.data.data);
          setuserId(response.data.data.id);
          setImageURL(response.data.data.image);
          const userData = response.data.data;
          const uniqueRates = [
            {
              key: "primary",
              title: "Pay Rate",
              rate: userData.payRate,
            },
            {
              key: "secondary",
              title: "Secondary Pay Rate",
              rate: userData.secondaryPayRate,
            },
            {
              key: "tertiary",
              title: "Tertiary Pay Rate",
              rate: userData.tertiaryPayRate,
            },
          ].filter(
            ({ rate }) => rate !== null && rate !== undefined && rate !== ""
          );
          const ratesList = uniqueRates.map(({ key, title, rate }) => ({
            key,
            title,
            label: `${title} - $${parseFloat(rate).toFixed(2)} / hr`,
            selectedLabel: `$${parseFloat(rate).toFixed(2)} / hr`,
            value: parseFloat(rate),
          }));

          setUserRates(ratesList);
          if (ratesList.length > 0) {
            const currentRate =
              formik.values.choosedRate !== "" &&
              formik.values.choosedRate !== undefined &&
              formik.values.choosedRate !== null
                ? parseFloat(formik.values.choosedRate)
                : null;
            const matchedRate = ratesList.find(
              (rateOption) => rateOption.value === currentRate
            );
            const selectedRate = matchedRate || ratesList[0];

            setChoosedRate(selectedRate.value);
            formik.setFieldValue("choosedRate", selectedRate.value);
          }
        } catch (error) {
          //console.error("Failed to fetch user details:", error);
        }
      };

      fetchUserDetails();
    }
  }, [userStateId]);

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const handleRadioClick = (newValue) => {
    formik.setValues({
      ...formik.values,
      paymentType: newValue,
    });
  };

  const shouldApplyFilledClass = (value) => {
    return value !== undefined && value !== null && value !== "";
  };

  const handleKeyDown = (event) => {
    // Allow only numbers, backspace, delete, arrow keys, and decimal point
    const allowedChars = /[0-9\b\t\r\f\v\↓\↑\→\←\.\.]/;
    if (!allowedChars.test(event.key) && event.key !== "Backspace") {
      event.preventDefault();
    }
  };

  function formatInvoiceAdditions(additions) {
    const numericValue = Number(additions);
    if (Number.isNaN(numericValue)) {
      return "0.00";
    }
    return numericValue.toFixed(2);
  }

  const handleWheel = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const handleDeleteEntry = (index) => {
    // Create a copy of formDataList
    const updatedFormDataList = [...formDataList];
    // Remove the entry at the specified index
    updatedFormDataList.splice(index, 1);
    // Update the state with the new list
    setFormDataList(updatedFormDataList);
  };

  const handleEditEntry = (index) => {
    const editedFormData = formDataList[index];
    if (!editedFormData) return;

    const parseMaybeDate = (value) => {
      if (!value) return "";
      const parsed = value instanceof Date ? value : new Date(value);
      return Number.isNaN(parsed.getTime()) ? "" : parsed;
    };

    const queryPeriod = parsePeriodFromSearch(location.search);
    const rowFrom = parseMaybeDate(editedFormData.payFromDate);
    const rowTo = parseMaybeDate(editedFormData.payToDate);
    const newFormValues = {
      payFromDate:
        rowFrom || queryPeriod.from || parseMaybeDate(formik.values.payFromDate),
      payToDate:
        rowTo || queryPeriod.to || parseMaybeDate(formik.values.payToDate),
      Additions: editedFormData.Additions,
      Deductions: editedFormData.Deductions,
      paymentType: editedFormData.paymentType || "hourly",
      hours: editedFormData.hours ?? "",
      minutes: editedFormData.minutes ?? "",
      salary: editedFormData.salary ?? "",
      choosedRate: "",
    };

    if (editedFormData.paymentType === "salary") {
      newFormValues.salary = editedFormData.salary;
    } else {
      newFormValues.hours = editedFormData.hours ?? 0;
      newFormValues.minutes = editedFormData.minutes ?? 0;
      newFormValues.choosedRate =
        editedFormData.hourlyRate !== undefined &&
        editedFormData.hourlyRate !== null &&
        editedFormData.hourlyRate !== ""
          ? parseFloat(editedFormData.hourlyRate)
          : "";
    }

    setAdditionsType(editedFormData.additionsType || "");
    setdeductionsType(editedFormData.deductionsType || "");
    setProperty(editedFormData.property || "");
    formik.setValues(newFormValues);

    if (editedFormData.paymentType !== "salary") {
      if (
        editedFormData.hourlyRate !== undefined &&
        editedFormData.hourlyRate !== null &&
        editedFormData.hourlyRate !== ""
      ) {
        const selectedRate = parseFloat(editedFormData.hourlyRate);
        formik.setFieldValue("choosedRate", selectedRate);
        setChoosedRate(selectedRate);
      }
    }

    setEditedIndex(index);
    setBtnText("Update");
  };

  const handleDataSubmission = async () => {
    if (!userStateId) {
      showMessage("Please select a user.");
      return;
    }
    if (
      formik.values.payFromDate === "" ||
      formik.values.payFromDate === undefined
    ) {
      showMessage("Please choose starting date.");
      return;
    }
    if (
      formik.values.payToDate === "" ||
      formik.values.payToDate === undefined
    ) {
      showMessage("Please choose ending date.");
      return;
    }

    if (formDataList.length === 0) {
      showMessage("Please add a record.");
      return;
    }

    const params = new URLSearchParams(location.search);
    const rangeId = rangeIdGet || params.get("rangeId");
    const startDateParam = params.get("startDate");

    const values = {
      invoiceId: invoiceId,
      userId,
      payDateId: rangeId,
      startDate: startDateParam,
      email: userEmail,
      payToDateInput: convertDateFormat(formik.values.payToDate.toString()),
      payFromDateInput: convertDateFormat(formik.values.payFromDate.toString()),
      formDataList,
    };

    setLoading(true);
    // console.log(values);

    try {
      const response = await axios.post(`${apiUrl}/editGenerateInvoice`, values);
      const data = response.data;
      if (response.status === 200) {
        if (data.status === 1) {
          setMessage(null);
          window.location.assign("/invoiceList");
        } else {
          showMessage("Error: " + data.message);
        }
      } else {
        showMessage("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      showMessage("An error occured");
    } finally {
      setLoading(false);
    }
  };

  const handleAddData = () => {
    // When the button shows 'Edit', treat it as 'Clear form' (except dates)
    if (btnText === "Edit") {
      const payFromDate = formik.values.payFromDate;
      const payToDate = formik.values.payToDate;
      const paymentType = formik.values.paymentType;
      formik.setValues({
        payFromDate: payFromDate,
        payToDate: payToDate,
        paymentType: paymentType,
        Additions: "",
        Deductions: "",
        salary: "",
        hours: "",
        minutes: "",
      });
      setAdditionsType("");
      setdeductionsType("");
      setProperty("");
      setBtnText("Add");
      return;
    }

    // Add/Update flow requires a selected user
    if (!userStateId) {
      showMessage("Please select a user.");
      return;
    }

    if (
      formik.values.payFromDate === "" ||
      formik.values.payFromDate === undefined
    ) {
      showMessage("Please choose starting date.");
      return;
    }
    if (
      formik.values.payToDate === "" ||
      formik.values.payToDate === undefined
    ) {
      showMessage("Please choose ending date.");
      return;
    }
    if (
      new Date(formik.values.payFromDate) > new Date(formik.values.payToDate)
    ) {
      showMessage("Please enter valid start date.");
      return;
    }
    if (property === "") {
      showMessage("Please select property.");
      return;
    }

    if (
      formik.values.paymentType === "" ||
      formik.values.paymentType === undefined
    ) {
      showMessage("Please select hourly, salary or overtime.");
      return;
    }

    if (formik.values.paymentType === "hourly") {
      const { hours, minutes } = formik.values;

      if (hours === "" || hours === undefined) {
        showMessage("Please enter hours worked.");
        return;
      }

      if (!Number.isInteger(Number(hours))) {
        showMessage("Hours must be a integer number not in decimal.");
        return;
      }

      if (minutes !== "" && minutes !== undefined) {
        if (!Number.isInteger(Number(minutes))) {
          showMessage("Minutes must be a integer number not in decimal.");
          return;
        }

        if (minutes < 0 || minutes > 59) {
          showMessage("Please enter minutes between 0–59.");
          return;
        }
      }
    }

    if (formik.values.paymentType === "overtime") {
      const { hours, minutes } = formik.values;

      if (hours === "" || hours === undefined) {
        showMessage("Please enter hours worked.");
        return;
      }

      if (!Number.isInteger(Number(hours))) {
        showMessage("Hours must be a integer number not in decimal.");
        return;
      }

      if (minutes !== "" && minutes !== undefined) {
        if (!Number.isInteger(Number(minutes))) {
          showMessage("Minutes must be a integer number not in decimal.");
          return;
        }

        if (minutes < 0 || minutes > 59) {
          showMessage("Please enter minutes between 0–59.");
          return;
        }
      }
    }

    if (formik.values.paymentType === "salary") {
      if (formik.values.salary === "" || formik.values.salary === undefined) {
        showMessage("Please enter employee salary.");
        return;
      }
    }

    const formDataWithDeductionsType = {
      ...formik.values,
      deductionsType: deductionsType,
      additionsType: additionsType,
      property: property,
      hourlyRate:
        formik.values.choosedRate !== undefined
          ? formik.values.choosedRate
          : user.payRate,
    };

    // Check if minutes is an empty string or undefined, and set it to 0 if true
    if (formik.values.minutes === "" || formik.values.minutes === undefined) {
      formDataWithDeductionsType.minutes = 0;
    }

    if (additionsType !== "") {
      if (
        formik.values.Additions === "" ||
        formik.values.Additions === undefined
      ) {
        showMessage("Please enter addition amount.");
        return;
      }
      if (formik.values.Additions == 0) {
        showMessage("Please enter valid addition amount.");
        return;
      }
    }

    if (deductionsType !== "") {
      if (
        formik.values.Deductions === "" ||
        formik.values.Deductions === undefined
      ) {
        showMessage("Please enter deduction amount.");
        return;
      }
      if (formik.values.Deductions == 0) {
        showMessage("Please enter valid deduction amount.");
        return;
      }
    }

    if (
      formik.values.Additions === "" ||
      formik.values.Additions === undefined ||
      formik.values.Additions === 0
    ) {
      formDataWithDeductionsType.Additions = 0;
    } else {
      if (additionsType === "") {
        showMessage("Please select addition type.");
        return;
      }
    }

    if (
      formik.values.Deductions === "" ||
      formik.values.Deductions === undefined ||
      formik.values.Deductions === 0
    ) {
      formDataWithDeductionsType.Deductions = 0;
    } else {
      if (deductionsType === "") {
        showMessage("Please select deduction type.");
        return;
      }
    }

    if (editedIndex !== null) {
      // Replace the existing row instead of delete + append
      setFormDataList((prev) => {
        const copy = [...prev];
        copy[editedIndex] = formDataWithDeductionsType;
        return copy;
      });
      setEditedIndex(null);
      setBtnText("Add");
    } else {
      // Append new row
      setFormDataList((prevFormDataList) => [
        ...prevFormDataList,
        formDataWithDeductionsType,
      ]);
    }

    const payFromDate = formik.values.payFromDate;
    const payToDate = formik.values.payToDate;
    formik.resetForm();

    formik.setValues({
      //...formik.values,
      Additions: "",
      Deductions: "",
      salary: "",
      hours: "",
      payFromDate: payFromDate,
      payToDate: payToDate,
    });

    // Clear form fields other than start date, end date, and radio checkbox
    // Create a new object for form values with cleared fields
    // const newFormValues = {
    //   payFromDate:formik.values.payFromDate,
    //   payToDate: formik.values.payToDate,
    //   payRate: "",
    //   hours: "",
    //   Additions: "",
    //   Deductions: "",
    //   salary: "",
    // };

    setAdditionsType("");
    setdeductionsType("");
    setProperty("");
    setBtnText("Add");
    if (userRates.length > 0) {
      setChoosedRate(userRates[0].value);
      formik.setFieldValue("choosedRate", userRates[0].value);
    }
    // Clear form fields by setting the new form values
    //formik.setValues(newFormValues);
  };

  function convertDateFormat(dateString) {
    const mnths = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };

    const dateArray = dateString.split(" ");
    const year = dateArray[3];
    const month = mnths[dateArray[1]];
    const day = dateArray[2];

    return `${year}-${month}-${day}`;
  }

  const getFormattedDate = (date) => formatDisplayDate(date);

  const toggleStartDateDropdown = () => {
    // setIsOpen(!isOpen);
    if (startDatePickerRef.current) {
      setIsOpen(true);
      startDatePickerRef.current.setOpen(true);
    }
  };

  const handleStartDateChange = (date, event) => {
    event.stopPropagation();
    // Set the selected date
    console.log(date);
    formik.setFieldValue("payFromDate", date);
    setIsOpen(false);
    // Close the date picker dropdown
    if (startDatePickerRef.current) {
      startDatePickerRef.current.setOpen(false);
    }
  };

  const toggleEndDateDropdown = () => {
    setIsOpenEndDate(true);
    if (endDatePickerRef.current) {
      endDatePickerRef.current.setOpen(true);
    }
  };

  const handleEndDateChange = (date, event) => {
    event.stopPropagation();
    // Set the selected date
    formik.setFieldValue("payToDate", date);
    setIsOpenEndDate(false);

    // Close the date picker dropdown
    if (endDatePickerRef.current) {
      endDatePickerRef.current.setOpen(false);
    }
  };

  // const handleSubmit = async (values) => {
  //   if (!userEmail) {
  //     showMessage("Please select a user.");
  //     return;
  //   }

  //   if (!values.payFromDate) {
  //     showMessage("Please enter starting date.");
  //     return;
  //   }
  //   if (!values.payToDate) {
  //     showMessage("Please enter ending date.");
  //     return;
  //   }
  //   if (!values.hours) {
  //     showMessage("Please enter hours worked.");
  //     return;
  //   }

  //   setLoading(true);
  //   values.userId = userId;
  //   values.email = userEmail;
  //   values.payToDateInput = convertDateFormat(values.payToDate.toString());
  //   values.payFromDateInput = convertDateFormat(values.payFromDate.toString());

  //   try {
  //     const response = await fetch(`${apiUrl}/generateInvoice`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(values),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       setInvoiceId(data.data.id);
  //       showMessage(data.message);
  //     } else {
  //       showMessage("Error: " + data.message);
  //     }
  //   } catch (error) {
  //     showMessage("An error occured");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const formik = useFormik({
    initialValues: {
      payFromMonth: "",
      payToMonth: "",
      payRate: "",
      payFromDate: "",
      payToDate: "",
      hours: "",
      minutes: "",
      Additions: "",
      Deductions: "",
      salary: "",
      paymentType: "",
    },
    validationSchema: yup.object({
      payFromDate: yup
        .string()
        .test(
          "is-before",
          "Starting date must be before Ending date",
          function (value) {
            const { payToDate } = this.parent;
            return (
              !value ||
              !payToDate ||
              moment(value).isBefore(payToDate) ||
              moment(value).isSame(payToDate)
            );
          }
        ),
      payToDate: yup
        .string()
        .test(
          "is-after",
          "Ending date must be after Starting date",
          function (value) {
            const { payFromDate } = this.parent;
            return (
              !value ||
              !payFromDate ||
              moment(value).isAfter(payFromDate) ||
              moment(value).isSame(payFromDate)
            );
          }
        ),
      hours: yup.number(),
      minutes: yup.number(),
      Additions: yup.number(),
      Deductions: yup.number(),
    }),
    //onSubmit: handleSubmit,
  });
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const params = new URLSearchParams(window.location.search);

  //     const rangeId = params.get("rangeId");

  //     if (rangeId) {

  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (formik.values.payToDate && formik.values.payFromDate) {
      handleFetchEmployees();
    }
  }, [formik.values.payToDate, formik.values.payFromDate]);

  useEffect(() => {
    if (isReady) {
      handleFetchEmployees();
    }
  }, [isReady]);

  const handleClearDateEnd = () => {
    console.log(isOpenEndDate);
    setIsOpenEndDate(0);
    console.log(isOpenEndDate);
  };
  // Fetch employees from the API
  // useEffect(() => {
  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${apiUrl}/getAllUsersForEmployeeInvoice`,
        {
          payFromDate: convertDateFormat(formik.values.payFromDate.toString()),
          payToDate: convertDateFormat(formik.values.payToDate.toString()),
        }
      );
      //console.log(response.data);
      const filteredEmployees = response.data.employees.filter(
        (employee) => !employee.hasInvoice
      );

      setEmployees(filteredEmployees);
      setPropertyList(response.data.propertyNames);
      setAdditionsTypeList(response.data.additionsNames);
      setDeductionssTypeList(response.data.deductionsNames);

      setLoading(false);
      //console.log(response.data);
    } catch (error) {
      //console.error("Failed to fetch employees:", error);
    }
  };
  const handleFetchEmployees = () => {
    if (
      formik.values.payToDate &&
      formik.values.payFromDate &&
      formik.values.payToDate.toString() != "" &&
      formik.values.payFromDate.toString() != ""
    ) {
      fetchEmployees();
    }
  };

  // }, [formik.values.payFromDate, formik.values.payToDate]);

  // const formik = useFormik({
  //   initialValues: {
  //     payFromMonth: "",
  //     payToMonth: "",
  //     payRate: "",
  //     payFromDate: "",
  //     payToDate: "",
  //     hours: "",
  //     Additions: "",
  //     Deductions: "",
  //   },
  //   validationSchema: yup.object({
  //     payFromDate: yup
  //       .string()
  //       .test(
  //         "is-before",
  //         "Starting date must be before Ending date",
  //         function (value) {
  //           const { payToDate } = this.parent;
  //           return (
  //             !value ||
  //             !payToDate ||
  //             moment(value).isBefore(payToDate) ||
  //             moment(value).isSame(payToDate)
  //           );
  //         }
  //       ),
  //     payToDate: yup
  //       .string()
  //       .test(
  //         "is-after",
  //         "Ending date must be after Starting date",
  //         function (value) {
  //           const { payFromDate } = this.parent;
  //           return (
  //             !value ||
  //             !payFromDate ||
  //             moment(value).isAfter(payFromDate) ||
  //             moment(value).isSame(payFromDate)
  //           );
  //         }
  //       ),
  //     hours: yup.number(),
  //     minutes: yup.number(),
  //     Additions: yup.number(),
  //     Deductions: yup.number(),
  //   }),
  //   onSubmit: async (values) => {
  //     if (!userEmail) {
  //       showMessage("Please select a user.");
  //       return;
  //     }

  //     if (!values.payFromDate) {
  //       showMessage("Please enter starting date.");
  //       return;
  //     }
  //     if (!values.payToDate) {
  //       showMessage("Please enter ending date.");
  //       return;
  //     }
  //     if (!values.hours) {
  //       showMessage("Please enter hours worked.");
  //       return;
  //     }

  //     setLoading(true);
  //     values.userId = userId;
  //     values.email = userEmail;
  //     values.payToDateInput = convertDateFormat(values.payToDate.toString());
  //     values.payFromDateInput = convertDateFormat(
  //       values.payFromDate.toString()
  //     );
  //     //console.log("Submitting the following data:", values);
  //     try {
  //       const response = await fetch(`${apiUrl}/generateInvoice`, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(values),
  //       });
  //       const data = await response.json();
  //       if (response.ok) {
  //         setInvoiceId(data.data.id);
  //         //window.alert(data.message);
  //         showMessage(data.message);
  //       } else {
  //         //window.alert("Error: " + data.message);
  //         showMessage("Error: " + data.message);
  //       }
  //     } catch (error) {
  //       //console.error("Error:", error);
  //       showMessage("An error occured");
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  // });

  const options = [
    ...employees.map((employee) => ({
      value: employee.id || userStateId,
      label: employee.email
        ? `${employee.name} (${employee.email})`
        : employee.name,
      style: {
        color: employee.hasInvoice ? "grey" : "inherit",
      },
    })),
  ];

  const propertyOptions = [
    ...propertyList.map((property) => ({
      value: property.NAME,
      label: property.NAME,
    })),
  ];

  const deductionsOptions = [
    { value: "", label: "Deduction Type" },
    ...deductionssTypeList.map((deductionssType) => ({
      value: deductionssType.NAME,
      label: deductionssType.NAME,
    })),
  ];

  const additionsOptions = [
    { value: "", label: "Addition Type" },
    ...additionsTypeList.map((additionsType) => ({
      value: additionsType.NAME,
      label: additionsType.NAME,
    })),
  ];

  return (
    <div className="feedback-parent-container">
      <NavBar />
      <TopNavBar />
      <PermissionDialog />
      <div
        className={`parent-container-generateInvoice ${!canEditPayslip ? "pointer-events-none opacity-60" : ""}`}
      >
        <div className="generate-invoice-admin-header">
          <div className="left-section">
            <h1 className="admin-header-title">
              <span className="admin-card-title-span">Payslip</span>
            </h1>
          </div>
          <div
            className="right-section custompayperiod"
            style={{ marginTop: "12px" }}
          >
            {/* <h1 className="admin-card-title form-heading-text margin-bottom">
                    <span className="admin-card-title-span" style={{marginRight:'50px'}}>Pay Period</span>
                  </h1> */}

            <div className="custom-datepicker">
              <div
                className="form-group-generateInvoice"
                onClick={toggleStartDateDropdown}
              >
                <div className="input-container-generateInvoice input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={startingDateIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="generate-invoice-form-input-container generate-invoice-date-input-hidden">
                    <div
                      className={`date-label ${
                        formik.values.payFromDate ? "date-label-fill" : ""
                      }`}
                    >
                      {getFormattedDate(formik.values.payFromDate) || ""}
                    </div>
                    <DatePicker
                      ref={startDatePickerRef}
                      className={`date-picker ${
                        formik.values.payFromDate ? "" : "hidden"
                      }`}
                      selected={formik.values.payFromDate}
                      onChange={handleStartDateChange} // Use the new handler
                      onBlur={formik.handleBlur}
                      shouldCloseOnSelect={true}
                      open={isOpen}
                    />
                    <div
                      className={`${
                        formik.values.payFromDate ? "date-label-filled" : ""
                      }`}
                    >
                      <label htmlFor="Starting Date">Starting Date</label>
                    </div>
                  </div>
                  {formik.touched.payFromDate && formik.errors.payFromDate && (
                    <div className="error-message">
                      {formik.errors.payFromDate}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="custom-datepicker">
              <div
                className="form-group-generateInvoice"
                onClick={toggleEndDateDropdown}
              >
                <div className="input-container-generateInvoice input-container-box">
                  <div className="icon-container">
                    <img
                      className="email-icon"
                      src={endingDateIcon}
                      alt="icon"
                    />
                  </div>
                  <div className="generate-invoice-form-input-container  generate-invoice-date-input-hidden">
                    <div
                      className={`date-label ${
                        formik.values.payToDate ? "date-label-fill" : ""
                      }`}
                    >
                      {getFormattedDate(formik.values.payToDate) || ""}
                    </div>

                    <DatePicker
                      ref={endDatePickerRef}
                      selected={formik.values.payToDate}
                      onChange={handleEndDateChange}
                      onBlur={formik.handleBlur}
                      dropdownMode="select"
                      open={isOpenEndDate}
                      // placeholderText="Ending Date"
                    />
                    <div
                      className={`${
                        formik.values.payToDate ? "date-label-filled" : ""
                      }`}
                    >
                      <label htmlFor="Ending Date">Ending Date</label>
                    </div>
                    {/* <button
                      type="button"
                      onClick={handleClearDateEnd}
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        position: 'absolute',
                        right: '10px', 
                        top: '10px' 
                      }}
                    >
                      &times; 
                    </button> */}
                  </div>
                  {formik.touched.payToDate && formik.errors.payToDate && (
                    <div className="error-message">
                      {formik.errors.payToDate}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* <button
              style={{ marginTop: '-15px' }}
              type="button"
              onClick={handleFetchEmployees}
              className="btn-generateInvoice new-btn-generateInvoice"
            >
              Apply
            </button> */}
          </div>

          {/* end date  */}
        </div>
        <div className="container-generateInvoice new-container-generateInvoice">
          <div className="left-panel">
            <div className="input-container-left-generateInvoice border-remove generate-left-panel-top-margin">
              <div className="scrollable-dropdown">
                <Select
                  id="employeeSelect"
                  placeholder="Choose Employee"
                  options={options}
                  value={
                    options.find((option) => option.value === userStateId) ||
                    null
                  }
                  // value={{
                  //   value: userEmail,
                  //   label: userEmail,
                  // }}

                  onFocus={() => setSelectOpen(true)}
                  onBlur={() => setSelectOpen(false)}
                  onChange={(selectedOption) => {
                    if (formDataList.length > 0) {
                      setFormDataList([]); // Set formDataList to empty array
                    }
                    setStateUserId(selectedOption.value);
                    formik.setFieldValue("employee", selectedOption.value);
                  }}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      maxHeight: "50vh",
                      overflowY: "scroll",
                    }),
                    control: (provided) => ({
                      ...provided,
                      width: "41vw",
                      backgroundColor: "#EDF6F0",
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      fontWeight: state.data.style.fontWeight,
                      color: state.data.style.color,
                    }),
                  }}
                  getOptionStyle={(option) => option.style}
                />
              </div>
              <div className="user-detail-main-invoice">
                {user && Object.keys(user).length > 0 ? (
                  <div className="user-detail-inner-div unallign-item width-fourty">
                    <div className=" generate-image-container new-generate-image-container">
                      {!imageURL && ( // If imageUrl is not available
                        <div className="user-image-container image-display-invoice-user">
                          <img src={DefaultEmployeeProfile} alt="User Image" />
                        </div>
                      )}
                      {imageURL && (
                        <div className="user-image-container image-display-invoice-user">
                          <img src={imageURL} alt="User Image" />
                        </div>
                      )}
                    </div>
                    <div className="right-container">
                      <div className="user-detail-text-container user-detail-text-style">
                        <p>User Details</p>
                      </div>

                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Name -
                        </span>
                        <span className="user-particular"> {user.name}</span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Email -
                        </span>
                        <span className="user-particular"> {user.email}</span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Pay Rate -{" "}
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(user.payRate)}/hr
                        </span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Secondary Pay Rate -{" "}
                        </span>
                        <span className="user-particular">
                          {" "}
                          ${formatInvoiceAdditions(user.secondaryPayRate)}/hr
                        </span>
                      </div>
                      <div className="generate-invoice-right-container-user-data padding-left-two">
                        <span className="generate-invoice-user-detail-left-text">
                          Tertiary Pay Rate -{" "}
                        </span>
                        <span className="user-particular">
                          {" "}
                          {user.tertiaryPayRate !== null &&
                          user.tertiaryPayRate !== undefined &&
                          user.tertiaryPayRate !== ""
                            ? `$${formatInvoiceAdditions(user.tertiaryPayRate)}/hr`
                            : "---"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="select-employye-detail">
                    Please select employee for details
                  </div>
                )}
              </div>
              <div>
                {user && Object.keys(user).length > 0 && (
                  <hr className="invoice-display-separator" />
                )}

                {formDataList.length > 0 && (
                  <>
                    <InvoiceDisplay
                      formDataList={formDataList}
                      onDelete={handleDeleteEntry}
                      onEdit={handleEditEntry}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "4%",
                      }}
                    >
                      {/* {invoiceId && (
                      <>
                        <Link
                          to="/invoiceDetail"
                          state={invoiceId}
                          className="btn-generateInvoice submit-form-generate"
                        >
                          Show Payslip
                        </Link>
                        
                      </>
                    )} */}
                      <button
                        className="btn-generateInvoice submit-form-generate"
                        style={{
                          width: "auto",
                          minWidth: "220px",
                          padding: "8px 28px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={handleDataSubmission}
                      >
                        Save Changes
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="right-panel">
            <div className="card-generateInvoice">
              <div className="card-body-generateInvoice">
                <form
                  // onSubmit={formik.handleSubmit}
                  className="form-container-generateInvoice"
                >
                  <h1 className="admin-card-title form-heading-text margin-bottom">
                    <span className="admin-card-title-span">Form</span>
                  </h1>
                  <div
                    className="form-group-generateInvoice"
                    // onClick={toggleStartDateDropdown}
                  >
                    <div className="input-container-generateInvoice input-container-box">
                      <div className="icon-container">
                        <img
                          className="email-icon"
                          src={propertyIcon}
                          alt="icon"
                        />
                      </div>
                      <div className="generate-invoice-form-input-container select-type padding-select-type-left">
                        <Select
                          placeholder={property ? "" : "Select Property"}
                          options={propertyOptions}
                          value={
                            property
                              ? propertyOptions.filter((option) =>
                                  property.includes(option.value)
                                )
                              : [] // Use an array to handle multiple selected options
                          }
                          isMulti // Enable multiple selection
                          onFocus={() => setSelectOpen(true)}
                          onBlur={() => setSelectOpen(false)}
                          onChange={(selectedOptions) => {
                            // Convert the selected options into a comma-separated string
                            const selectedValues = selectedOptions
                              .map((option) => option.value)
                              .join(", ");

                            // Update the state and Formik value with the comma-separated string
                            setProperty(selectedValues);
                            formik.setFieldValue(
                              "addressProperty",
                              selectedValues
                            );
                          }}
                          styles={{
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "50vh",
                              overflowY: "scroll",
                            }),
                            control: (provided, state) => ({
                              ...provided,
                              width: "26vw",
                              backgroundColor: "#ffff",
                              border: "none",
                              boxShadow: state.isFocused ? "none" : "none",
                            }),
                            placeholder: (provided) => ({
                              ...provided,
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              lineHeight: "21px",
                              fontWeight: 300,
                            }),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="hours-minutes-container">
                    <div className="form-group-generateInvoice hourly-salary-container">
                      <div className=" input-container-generateInvoice-radio width-full gap-two">
                        <div
                          className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours width-eighty"
                          onClick={() => handleRadioClick("hourly")}
                        >
                          <div className=" display-flex align-radio">
                            <input
                              type="radio"
                              id="hourly"
                              name="paymentType"
                              value="hourly"
                              checked={formik.values.paymentType === "hourly"}
                              onChange={formik.handleChange}
                            />
                            <span className="radio-label">Hourly</span>
                          </div>
                          {formik.touched.hours && formik.errors.hours && (
                            <div className="error-message">
                              {formik.errors.hours}
                            </div>
                          )}
                        </div>

                        <div
                          className="generate-invoice-form-input-container small-text margin-left-allign-hours margin-select-type padding-select-type-left"
                          onClick={() => handleRadioClick("salary")}
                        >
                          <div className="display-flex align-radio">
                            <input
                              type="radio"
                              id="salary"
                              name="paymentType"
                              value="salary"
                              checked={formik.values.paymentType === "salary"}
                              onChange={formik.handleChange}
                            />
                            <span className="radio-label">Salary</span>
                          </div>
                        </div>
                        <div
                          className="generate-invoice-form-input-container small-text margin-left-allign-hours margin-select-type padding-select-type-left"
                          onClick={() => handleRadioClick("overtime")}
                        >
                          <div className="display-flex align-radio">
                            <input
                              type="radio"
                              id="overtime"
                              name="paymentType"
                              value="overtime"
                              checked={formik.values.paymentType === "overtime"}
                              onChange={formik.handleChange}
                            />
                            <span className="radio-label">Overtime</span>
                          </div>
                        </div>
                        {formik.touched.minutes && formik.errors.minutes && (
                          <div className="error-message">
                            {formik.errors.minutes}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {formik.values.paymentType === "salary" && (
                    <div className="form-group-generateInvoice">
                      <div className="input-container-generateInvoice input-container-box">
                        <div className="icon-container">
                          <img
                            className="email-icon"
                            src={salaryIcon}
                            alt="icon"
                          />
                        </div>
                        <div className="generate-invoice-form-input-container">
                          <input
                            type="number"
                            min="0"
                            name="salary"
                            pattern="[0-9]*"
                            value={formik.values.salary}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onWheel={handleWheel}
                            onKeyDown={handleKeyDown}
                            placeholder=""
                            className={
                              shouldApplyFilledClass(formik.values.salary)
                                ? "filled"
                                : ""
                            }
                          />
                          <label htmlFor="salary">Salary</label>
                        </div>
                        {formik.touched.hours && formik.errors.hours && (
                          <div className="error-message">
                            {formik.errors.hours}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {(formik.values.paymentType === "hourly" ||
                    formik.values.paymentType === "overtime") && (
                    <div className="hours-minutes-container">
                      <div className="form-group-generateInvoice">
                        <div className="input-container-generateInvoice display-justify gap-two">
                          <div className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours flex-one">
                            <div className="icon-container">
                              <img
                                className="email-icon"
                                src={hoursWorkedIcon}
                                alt="icon"
                              />
                            </div>
                            <div className="input-container-hours-padding">
                              <input
                                type="number"
                                pattern="[0-9]*"
                                min="0"
                                name="hours"
                                value={formik.values.hours}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                onKeyDown={(e) => {
                                  // Prevent ".", ",", "e", "-", "+", etc.
                                  if (
                                    ["e", "E", ".", ",", "+", "-"].includes(
                                      e.key
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                  handleKeyDown?.(e); // If you have other key logic
                                }}
                                onWheel={(e) => {
                                  e.target.blur(); // Prevent scroll increment
                                  handleWheel?.(e);
                                }}
                                placeholder=""
                                className={
                                  shouldApplyFilledClass(formik.values.hours)
                                    ? "filled"
                                    : ""
                                }
                              />
                              <label
                                className="label-hoursWorked"
                                htmlFor="hoursWorked"
                              >
                                Hours
                              </label>
                            </div>
                            {formik.touched.hours && formik.errors.hours && (
                              <div className="error-message">
                                {formik.errors.hours}
                              </div>
                            )}
                          </div>

                          <div className="generate-invoice-form-input-container small-text margin-left-allign-hours flex-one margin-select-type padding-select-type-left">
                            <div className="icon-container">
                              <img
                                className="email-icon"
                                src={minutesWorkedIcon}
                                alt="icon"
                              />
                            </div>
                            <div className="input-container-hours-padding">
                              <input
                                type="number"
                                pattern="[0-9]*"
                                min="0"
                                max="59" // ✅ corrected max
                                name="minutes"
                                value={formik.values.minutes}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                onKeyDown={(e) => {
                                  if (
                                    ["e", "E", ".", ",", "+", "-"].includes(
                                      e.key
                                    )
                                  ) {
                                    e.preventDefault();
                                  }
                                  handleKeyDown?.(e);
                                }}
                                onWheel={(e) => {
                                  e.target.blur();
                                  handleWheel?.(e);
                                }}
                                placeholder=""
                                className={
                                  shouldApplyFilledClass(formik.values.minutes)
                                    ? "filled"
                                    : ""
                                }
                              />
                              <label
                                className="label-hoursWorked"
                                htmlFor="minutesWorked"
                              >
                                Min
                              </label>
                            </div>
                          </div>
                          {formik.touched.minutes && formik.errors.minutes && (
                            <div className="error-message">
                              {formik.errors.minutes}
                            </div>
                          )}

                          <div className="generate-invoice-form-input-container small-text margin-left-allign-hours select-type flex-one margin-select-type padding-select-type-left">
                            <div className="icon-container">
                              <img
                                className="email-icon"
                                src={payrateIcon}
                                alt="icon"
                              />
                            </div>

                            <Select
                              placeholder={
                                choosedRate !== null &&
                                choosedRate !== undefined
                                  ? formik.values.paymentType === "overtime"
                                    ? `$${parseFloat(choosedRate).toFixed(
                                        2
                                      )} / hr * 1.5`
                                    : `$${parseFloat(choosedRate).toFixed(
                                        2
                                      )} / hr`
                                  : ""
                              }
                              options={userRates}
                              value={
                                choosedRate !== null &&
                                choosedRate !== undefined
                                  ? {
                                      key: userRates.find(
                                        (option) => option.value === choosedRate
                                      )?.key,
                                      title: userRates.find(
                                        (option) => option.value === choosedRate
                                      )?.title,
                                      value: choosedRate,
                                      label: userRates.find(
                                        (option) => option.value === choosedRate
                                      )?.label,
                                      selectedLabel:
                                        formik.values.paymentType === "overtime"
                                          ? `$${parseFloat(choosedRate).toFixed(
                                              2
                                            )} / hr * 1.5`
                                          : `$${parseFloat(choosedRate).toFixed(
                                              2
                                            )} / hr`,
                                    }
                                  : null
                              }
                              formatOptionLabel={(option, { context }) =>
                                context === "menu"
                                  ? formik.values.paymentType === "overtime"
                                    ? `${option.title} - $${parseFloat(
                                        option.value
                                      ).toFixed(2)} / hr * 1.5`
                                    : option.label
                                  : option.selectedLabel ||
                                    `$${parseFloat(option.value).toFixed(2)} / hr`
                              }
                              onFocus={() => setSelectOpen(true)}
                              onBlur={() => setSelectOpen(false)}
                              onChange={(selectedOption) => {
                                setChoosedRate(selectedOption.value);
                                formik.setFieldValue(
                                  "choosedRate",
                                  selectedOption.value
                                );
                              }}
                              styles={{
                                menu: (provided) => ({
                                  ...provided,
                                  maxHeight: "50vh",
                                  overflowY: "scroll",
                                  minWidth: "18vw",
                                  width: "max-content",
                                }),
                                control: (provided, state) => ({
                                  ...provided,
                                  width: "12vw",
                                  backgroundColor: "#ffff",
                                  border: "none",
                                  boxShadow: state.isFocused ? "none" : "none",
                                }),
                                option: (provided) => ({
                                  ...provided,
                                  whiteSpace: "nowrap",
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  fontFamily: "Montserrat",
                                  fontSize: "14px",
                                  lineHeight: "21px",
                                  fontWeight: 300,
                                }),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="hours-minutes-container">
                    <div className="form-group-generateInvoice">
                      <div className="input-container-generateInvoice display-justify gap-two">
                        <div className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours flex-one">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={additionsIcon}
                              alt="icon"
                            />
                          </div>
                          <div className="input-container-hours-padding ">
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min="0"
                              name="Additions"
                              value={formik.values.Additions}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              onKeyDown={handleKeyDown}
                              placeholder=""
                              onWheel={handleWheel}
                              //className={formik.values.Additions ? 'filled' : ''}
                              className={
                                shouldApplyFilledClass(formik.values.Additions)
                                  ? "filled"
                                  : ""
                              }
                            />
                            <label
                              className="label-hoursWorked"
                              htmlFor="Additions"
                            >
                              Additions
                            </label>
                          </div>
                          {formik.touched.Additions &&
                            formik.errors.Additions && (
                              <div className="error-message">
                                {formik.errors.Additions}
                              </div>
                            )}
                        </div>

                        <div className="generate-invoice-form-input-container small-text margin-left-allign-hours select-type flex-one margin-select-type padding-select-type-left">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={additionsIcon}
                              alt="icon"
                            />
                          </div>

                          <Select
                            placeholder={additionsType ? "" : "Addition Type"}
                            options={additionsOptions}
                            value={
                              additionsType
                                ? additionsOptions.find(
                                    (option) => option.value === additionsType
                                  )
                                : ""
                            }
                            // value={{
                            //   value: userEmail,
                            //   label: userEmail,
                            // }}

                            onFocus={() => setSelectOpen(true)}
                            onBlur={() => setSelectOpen(false)}
                            onChange={(selectedOption) => {
                              setAdditionsType(selectedOption.value);
                              formik.setFieldValue(
                                "additionsType",
                                selectedOption.value
                              );
                            }}
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "50vh",
                                overflowY: "scroll",
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                width: "12vw",
                                backgroundColor: "#ffff",
                                border: "none",
                                boxShadow: state.isFocused ? "none" : "none",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontFamily: "Montserrat",
                                fontSize: "14px",
                                lineHeight: "21px",
                                fontWeight: 300,
                              }),
                            }}
                          />
                        </div>
                        {/* {formik.touched.minutes &&
                              formik.errors.minutes && (
                                <div className="error-message">
                                  {formik.errors.minutes}
                                </div>
                              )} */}
                      </div>
                    </div>
                  </div>
                  <div className="hours-minutes-container">
                    <div className="form-group-generateInvoice">
                      <div className="input-container-generateInvoice display-justify gap-two">
                        <div className="generate-invoice-form-input-container allign-hours-icon margin-left-allign-hours flex-one">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={deductionsIcon}
                              alt="icon"
                            />
                          </div>
                          <div className="input-container-hours-padding">
                            <input
                              type="number"
                              pattern="[0-9]*"
                              min="0"
                              name="Deductions"
                              value={formik.values.Deductions}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              onKeyDown={handleKeyDown}
                              placeholder=""
                              onWheel={handleWheel}
                              className={
                                shouldApplyFilledClass(formik.values.Deductions)
                                  ? "filled"
                                  : ""
                              }
                              // className={formik.values.Deductions ? 'filled' : ''}
                            />
                            <label
                              id="label-deduction-margin"
                              className="label-hoursWorked"
                              htmlFor="Deductions"
                            >
                              Deductions
                            </label>
                          </div>
                          {formik.touched.Deductions &&
                            formik.errors.Deductions && (
                              <div className="error-message">
                                {formik.errors.Deductions}
                              </div>
                            )}
                        </div>

                        <div className="generate-invoice-form-input-container small-text margin-left-allign-hours select-type flex-one margin-select-type padding-select-type-left">
                          <div className="icon-container">
                            <img
                              className="email-icon"
                              src={deductionsIcon}
                              alt="icon"
                            />
                          </div>
                          <Select
                            placeholder={deductionsType ? "" : "Deduction Type"}
                            options={deductionsOptions}
                            value={
                              deductionsType
                                ? deductionsOptions.find(
                                    (option) => option.value === deductionsType
                                  )
                                : ""
                            }
                            onFocus={() => setSelectOpen(true)}
                            onBlur={() => setSelectOpen(false)}
                            onChange={(selectedOption) => {
                              setdeductionsType(selectedOption.value);
                              formik.setFieldValue(
                                "deductionsType",
                                selectedOption.value
                              );
                            }}
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "50vh",
                                overflowY: "scroll",
                              }),
                              control: (provided, state) => ({
                                ...provided,
                                width: "12vw",
                                height: "2vh",

                                backgroundColor: "#ffff",
                                border: "none",
                                boxShadow: state.isFocused ? "none" : "none",
                              }),
                              placeholder: (provided) => ({
                                ...provided,
                                fontFamily: "Montserrat",
                                fontSize: "13px",
                                lineHeight: "21px",
                                fontWeight: 300,
                              }),
                            }}
                          />
                        </div>
                        {formik.touched.minutes && formik.errors.minutes && (
                          <div className="error-message">
                            {formik.errors.minutes}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {loading && <LoaderForm />}{" "}
                  {/* Show loader if loading is true */}
                  {message && (
                    // <div className="custom-popup">
                    //   {message}
                    // </div>
                    <div className="custom-modal">
                      <div className="modal-content">{message}</div>
                    </div>
                  )}
                  <div className="text-allign-centre">
                    <div>
                      <button
                        type="button"
                        onClick={handleAddData}
                        className="btn-generateInvoice new-btn-generateInvoice"
                      >
                        {btnText}
                      </button>
                    </div>
                    <div className="generate-btn-margin">
                      {/* <button
                        type="submit"
                        className="btn-generateInvoice new-btn-generateInvoice"
                      >
                        Generate
                      </button> */}
                    </div>

                    {/* {invoiceId && (
                      <>
                        <Link
                          to="/invoiceDetail"
                          state={invoiceId}
                          className="show-invoice-btn"
                        >
                          Show Payslip
                        </Link>
                        
                      </>
                    )} */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditInvoice;
